const firebaseConfig = {
    apiKey: "AIzaSyDKZdcl-sIRtxiSlkaEDKbua4yNGDjPkWA",
    authDomain: "express-ef393.firebaseapp.com",
    databaseURL: "https://express-ef393.firebaseio.com",
    projectId: "express-ef393",
    storageBucket: "express-ef393.appspot.com",
    messagingSenderId: "537830711213",
    appId: "1:537830711213:web:d0009b9846fa206eda4b24",
    measurementId: "G-CPV4427PTB",
};

module.exports = { firebaseConfig };
